var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-form-fromarchetype',{attrs:{"formArchetype":_vm.formArchetype,"source":_vm.source},on:{"updated":_vm.triggerUpdated},model:{value:(_vm.workingValue),callback:function ($$v) {_vm.workingValue=$$v},expression:"workingValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }